/**
 * /signed-out route. Public, sits OUTSIDE the Layout's AuthGate so it
 * renders instead of triggering a silent re-SSO. Detects `?everywhere=1`
 * (set by the auth-logout lambda after a full Microsoft sign-out) and
 * renders broader-scope copy in that case.
 */

import { useSearchParams } from 'react-router-dom';
import { getLoginUrl } from '@/lib/useSession';

export function SignedOut() {
  const [params] = useSearchParams();
  const everywhere = params.get('everywhere') === '1';

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-amp-cream px-4 dark:bg-amp-dark-bg">
      <div className="w-full max-w-md rounded-lg border border-amp-line bg-amp-white p-8 text-center shadow-sm dark:border-amp-dark-line dark:bg-amp-dark-surface">
        <p className="text-xs uppercase tracking-wide text-amp-olive dark:text-amp-olive-dark mb-2">
          Cockpit
        </p>
        <h1 className="text-2xl font-semibold text-amp-ink dark:text-amp-dark-ink mb-3">
          {everywhere
            ? "You've been signed out of Microsoft 365"
            : "You've been signed out of Cockpit"}
        </h1>
        <p className="text-sm text-amp-ink-muted dark:text-amp-dark-ink-muted mb-6">
          {everywhere
            ? 'Your Cockpit, Outlook, Teams, and other Microsoft 365 apps are all signed out. Signing back in will require your password and MFA.'
            : 'Your Cockpit session is closed. Your Microsoft 365 sign-in stays active, so signing back into Cockpit will be one click.'}
        </p>
        <a
          href={getLoginUrl('/')}
          className="inline-flex items-center justify-center rounded-md bg-amp-olive px-4 py-2 text-sm font-medium text-amp-cream hover:bg-amp-olive-dark dark:bg-amp-olive-dark dark:text-amp-dark-bg dark:hover:bg-amp-olive"
        >
          Sign in to Cockpit
        </a>
      </div>
    </div>
  );
}
